module.exports = __webpack_public_path__ + "media/images/ioscorweb-ed78f04b3f275ec7ca841996a23b15e2.png";